module.exports = __webpack_public_path__ + "static/media/ZertifikatFotoKlein.5c6a5e2c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/ZertifikatFotoKlein.jpg
// module id = 333
// module chunks = 0